
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';
import StudentEnrollments from '../StudentEnrollments';
import AddEnrollmentDialog from '@/components/enrollments/AddEnrollmentDialog';

interface StudentEnrollmentsCardProps {
  studentId: string;
}

const StudentEnrollmentsCard: React.FC<StudentEnrollmentsCardProps> = ({ studentId }) => {
  return (
    <Card className="mt-6">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle>Enrollments</CardTitle>
        <AddEnrollmentDialog studentId={studentId}>
          <Button size="sm">
            <PlusCircle className="mr-2 h-4 w-4" />
            Add Enrollment
          </Button>
        </AddEnrollmentDialog>
      </CardHeader>
      <CardContent>
        <StudentEnrollments studentId={studentId} />
      </CardContent>
    </Card>
  );
};

export default StudentEnrollmentsCard;
